export default __webpack_public_path__ + "static/media/dummy_gateway.23892563.png";